import React from 'react';
import { QoraAssistantShell } from '../../components/qora-assistant/organisms/QoraAssistantShell';

export const QoraAssistantPage: React.FC = () => {
  return (
    <div
      className="h-[calc(100vh-5rem)]"
      data-test-id="qora-assistant-page"
    >
      <QoraAssistantShell />
    </div>
  );
};
